module.exports = __webpack_public_path__ + "static/media/order_icon8.c0279714.png";